export const CANCEL_STEP = {
    CANCEL_A: 'cancelA',
    CANCEL_B: 'cancelB',
};

export const STATUS_REPORT_STEP = {
    STATUS_REPORT_STEP_A: 'STATUS_REPORT_STEP_A',
    STATUS_REPORT_STEP_B: 'STATUS_REPORT_STEP_B',
}


